<template>
    <div>
        <CRow>
            <CCol sm="12">
                <h1>{{ i18n.otp.title }}</h1>
            </CCol>
        </CRow>
        <CRow style="margin-top: 10px">
            <CCol sm="12">
                <div style="font-size: 1.1rem">
                    {{ i18n.otp.subTitle }}
                    <CButton @click="warningModal = true" color="linkedin" class="btn-brand ml-2">
                        <svg width="1.5em" height="1.5em" viewBox="0 0 1408 1408">
                            <path
                                d="M384 1024v128H256v-128h128zm0-768v128H256V256h128zm768 0v128h-128V256h128zM128 1279h384V896H128v383zm0-767h384V128H128v384zm768 0h384V128H896v384zM640 768v640H0V768h640zm512 512v128h-128v-128h128zm256 0v128h-128v-128h128zm0-512v384h-384v-128H896v384H768V768h384v128h128V768h128zM640 0v640H0V0h640zm768 0v640H768V0h640z"
                                fill="currentColor"
                            />
                        </svg>
                        Download
                    </CButton>
                </div>
            </CCol>
        </CRow>
        <CRow class="mt-5">
            <CCol>
                <CCard v-for="(val, index) in data" :key="index" class="mb-0">
                    <CButton @click="accordion = accordion === index ? false : index" block color="link" class="text-left shadow-none card-header">
                        <h5 class="m-0">{{ val.app_name }}</h5>
                    </CButton>
                    <CCollapse :show="accordion === index">
                        <CCardBody>
                            <CRow>
                                <CCol class="d-flex justify-content-center">
                                    <qrcode-vue
                                        :value="`otpauth://totp/${val.app_name}@${val.account}?secret=${val.secret}&issuer=INNOLUX&digits=6&period=30`"
                                        :size="300"
                                        level="H"
                                        class="img-thumbnail rounded"
                                    />
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCollapse>
                </CCard>
            </CCol>
        </CRow>
        <CModal centered size="lg" :show.sync="warningModal">
            <template #header-wrapper>
                <header style="display: nano"></header>
            </template>
            <template #footer-wrapper>
                <footer style="display: nano"></footer>
            </template>
            <CRow class="text-center mb-2">
                <CCol>
                    <h3>
                        請掃描 QRCode 下載 APP<br />
                        (Please scan QRCode to download)
                    </h3>
                </CCol>
            </CRow>
            <CRow class="text-center">
                <CCol sm="12" xl="6">
                    <CCard accent-color="primary">
                        <CCardBody>
                            <h4 class="mb-2">Android</h4>
                            <qrcode-vue :value="`https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2`" :size="300" level="H" />
                        </CCardBody>
                    </CCard>
                </CCol>
                <CCol sm="12" xl="6">
                    <CCard accent-color="danger">
                        <CCardBody>
                            <h4 class="mb-2">IOS</h4>
                            <qrcode-vue :value="`https://apps.apple.com/tw/app/google-authenticator/id388497605`" :size="300" level="H" />
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>
        </CModal>
    </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue';
import { getUrlLang } from '@/services/check';
import { getLangString } from '@/services/lang';

export default {
    name: 'PersonalQRCode',
    components: { QrcodeVue },
    data() {
        return {
            warningModal: false,
            accordion: 0,
            i18n: null,
        };
    },
    props: {
        data: Array,
    },
    created() {
        this.i18n = getLangString(getUrlLang());
    },
};
</script>
